const state = {
    isMapView: false,
    isClosing: false,
    defaultZoomLevel: [],
};


export { state };